import { createFileRoute } from '@tanstack/react-router'
import { ScreenSharePage } from '@/components/screen-share/screen-share-page'
export const Route = createFileRoute('/share-screen')({ component: ScreenSharePage })
